<div *ngIf="loading === true" class="overlay">
  <img src="../../../assets/images/loading.gif" class="loadImg" />
</div>
<div class="container">
  <table class="table table-hover table-dark usersTable">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">{{'name' | translate}}</th>
        <th scope="col">{{'email' | translate}}</th>
        <th scope="col">Password</th>
        <th scope="col">{{'reads' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users ; let i=index">
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.password }}</td>
        <td>{{ user?.reads?.length }}</td>
      </tr>
    </tbody>
  </table>
</div>
